<script>

    export let message = ''

</script>

<span class="span has-tooltip-multiline"  data-tooltip={message} >
    <slot></slot>
</span>